import React from "react";

function Dashboard(props) {
  return <div className="dasboard">{props.children}</div>;
}

export default Dashboard;
